module.exports = __webpack_public_path__ + "media/bootstrap-icons/wallet-fill-a39b7dea.svg";